module.exports = __webpack_public_path__ + "static/media/registration.e4ecd095.svg";